const STATUS_ITEMS = [
  { id: 1, label: "Checked Out", color: "#EF4444" },
  { id: 2, label: "Enroute", color: "#F97316" },
  { id: 3, label: "On Site", color: "#22C55E" },
  { id: 4, label: "Getting Parts", color: "#A855F7" },
];

const TechnicianStatus = ({ status }) => {
  const parsedStatus = Number(status);
  const activeItem = STATUS_ITEMS.find((item) => item.id === parsedStatus);

  if (!activeItem) return null;

  return (
    <div
      style={{ backgroundColor: activeItem.color }}
      className="w-[85px] h-[22px] flex items-center justify-center rounded-[10px] font-OpenSansBold text-[11px] text-titleColor"
    >
      {activeItem.label}
    </div>
  );
};

export default TechnicianStatus;
